import { render, staticRenderFns } from "./ProductSwitcherDialog.vue?vue&type=template&id=6cc719d4&scoped=true"
import script from "./ProductSwitcherDialog.vue?vue&type=script&lang=js"
export * from "./ProductSwitcherDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductSwitcherDialog.vue?vue&type=style&index=0&id=6cc719d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc719d4",
  null
  
)

export default component.exports